exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{position:relative}.hooper-pagination{top:-10%;padding:0;bottom:auto;right:auto;-webkit-transform:unset;transform:unset}.navigation{position:absolute;bottom:20px}.navigation span{cursor:pointer}.navigation span:first-child{margin-right:15px}.navigation span i{color:#898e98}.slide-pagination{position:absolute;top:-25px}.slide-pagination span{display:inline-block;width:7px;height:5.5px;opacity:.8;margin-right:7px;border-radius:4px;cursor:pointer}.slide-pagination span.active{width:17px}", ""]);

// exports
